import { cva } from "class-variance-authority"

// SCSS-based avatar variants using WeLoop design system classes
export const avatarVariants = cva(
  "wl-avatar", // Base WeLoop avatar class
  {
    variants: {
      size: {
        default: "", // Default size is handled by wl-avatar
        sm: "wl-avatar-sm",
        lg: "wl-avatar-lg",
        xl: "wl-avatar-xl",
        "2xl": "wl-avatar-2xl",
      },
      variant: {
        default: "", // Default variant
        "add-new": "wl-avatar-add-new",
        clickable: "wl-avatar-clickable",
        "width-100": "wl-w-100",
      },
      shape: {
        default: "",
        sm: "wl-avatar-shape-sm",
        md: "wl-avatar-shape-md",
        lg: "wl-avatar-shape-lg",
        xl: "wl-avatar-shape-xl",
        "2xl": "wl-avatar-shape-2xl",
      },
    },
    defaultVariants: {
      size: "default",
      variant: "default",
      shape: "default",
    },
  }
)

// Fallback variants for AvatarFallback component
export const avatarFallbackVariants = cva(
  "wl-avatar-fallback", // Base WeLoop avatar fallback class
  {
    variants: {
      size: {
        default: "", // Default size is handled by wl-avatar-fallback
        sm: "wl-avatar-fallback-sm",
        lg: "wl-avatar-fallback-lg",
        xl: "wl-avatar-fallback-xl",
        "2xl": "wl-avatar-fallback-2xl",
      },
    },
    defaultVariants: {
      size: "default",
    },
  }
)

// Image variants for AvatarImage component
export const avatarImageVariants = cva(
  "", // Base class for avatar images
  {
    variants: {
      loaded: {
        true: "loaded",
        false: "",
      },
    },
    defaultVariants: {
      loaded: false,
    },
  }
) 